import React from "react";
import { ENROLLMENT_ERROR_PAGE, ENROLLMENT_STEPS_NUMBER } from "constants/enrollment";
import EligibilityCheck from "./steps/EligibilityCheck";
import EligibilityCheckMoreInfo from "./steps/EligibilityCheckMoreInfo";
import EligibilityError, { EligibilityErrorUnderAge } from "./steps/EligibilityError";
import EligibilitySuccess from "./steps/EligibilitySuccess";
import CarePathwayTreat from "./steps/CarePathwayTreat";
import CarePathwayPrevent from "./steps/CarePathwayPrevent";
import ProgramResult from "./steps/ProgramResult";
import CreateAccount from "./steps/CreateAccount";
import ShippingAddress from "./steps/ShippingAddress";
import EnrollmentSuccess from "./steps/EnrollmentSuccess";

export default function StepRenderer({
    step,
    formData,
    errorScreen,
    resetToInitialStep,
    isSubmitting,
    handleFormChange,

    handleCheckEligibility,
    handleCheckEligibilityMoreInfo,
    handleEligibilitySuccessNext,
    handleTreatNext,
    handlePreventSubmit,
    handleProgramContinue,
    handleMigrateUser,
    handleCreateAccount,
    handleAddShippingAddress,
    handleVerifyShippingAddress,
}) {
    switch (step) {
        case ENROLLMENT_STEPS_NUMBER.ELIGIBILITY_CHECK:
            if (errorScreen === ENROLLMENT_ERROR_PAGE.UNDER_AGE) {
                return <EligibilityErrorUnderAge onTryAgain={resetToInitialStep} />;
            }
            return (
                <EligibilityCheck
                    formData={formData.eligibility}
                    onChange={handleFormChange}
                    onSubmit={handleCheckEligibility}
                    isSubmitting={isSubmitting}
                />
            );
        case ENROLLMENT_STEPS_NUMBER.ELIGIBILITY_MORE_INFO:
            if (errorScreen === ENROLLMENT_ERROR_PAGE.DEFAULT) {
                return <EligibilityError onTryAgain={resetToInitialStep} />;
            }
            return (
                <EligibilityCheckMoreInfo
                    formData={formData.moreInfo}
                    onChange={handleFormChange}
                    onSubmit={handleCheckEligibilityMoreInfo}
                    isSubmitting={isSubmitting}
                />
            );
        case ENROLLMENT_STEPS_NUMBER.ELIGIBILITY_SUCCESS:
            return (
                <EligibilitySuccess
                    onSubmit={handleEligibilitySuccessNext}
                />
            );
        case ENROLLMENT_STEPS_NUMBER.CARE_PATHWAY_TREAT:
            return (
                <CarePathwayTreat
                    options={formData.internalFormData.treatQuestionOption}
                    selected={formData.treat.treatOptions}
                    onChange={handleFormChange}
                    onSubmit={handleTreatNext}
                    isSubmitting={isSubmitting}
                />
            );
        case ENROLLMENT_STEPS_NUMBER.CARE_PATHWAY_PREVENT:
            return (
                <CarePathwayPrevent
                    options={formData.internalFormData.preventQuestionOption}
                    selected={formData.prevent.preventOptions}
                    onChange={handleFormChange}
                    onSubmit={handlePreventSubmit}
                    isSubmitting={isSubmitting}
                />
            );
        case ENROLLMENT_STEPS_NUMBER.PROGRAM_RESULT:
            return (
                <ProgramResult
                    program={formData.internalFormData.programId?.toUpperCase()}
                    onContinue={handleProgramContinue}
                    onNoThanks={resetToInitialStep}
                />
            );
        case ENROLLMENT_STEPS_NUMBER.CREATE_ACCOUNT:
            return (
                <CreateAccount
                    formData={formData.createAccount}
                    onChange={handleFormChange}
                    onMigrateUser={handleMigrateUser}
                    onSubmit={handleCreateAccount}
                    isSubmitting={isSubmitting}
                />
            );
        case ENROLLMENT_STEPS_NUMBER.SHIPPING_ADDRESS:
            return (
                <ShippingAddress
                    formData={formData.shipping}
                    onChange={(field, value) => handleFormChange("shipping", field, value)}
                    onSubmit={handleAddShippingAddress}
                    onVerifyShippingAddress={handleVerifyShippingAddress}
                    isSubmitting={isSubmitting}
                />
            );
        case ENROLLMENT_STEPS_NUMBER.SUCCESS:
            return <EnrollmentSuccess />;
        default:
            return null;
    }
}
